import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Activity } from '@spike/activity-model';
import { TimelineGroup } from 'components/UI/V3/Timeline/Group/TimelineGroup';
import { Timeline } from 'components/UI/V3/Timeline/Timeline';
import React from 'react';
import { ReportActivityTimelineItem } from './ReportActivityTimelineItem/ReportActivityTimelineItem';
import { useReportBuilder } from './ReportBuilderProvider';
import styles from './ReportBuilder.module.scss';
import { Label } from 'components/UI/V3/Forms/Label/Label';

interface TimelinePreviewProps {
    /* eslint-disable-next-line no-unused-vars */
    onEdit: (activity: Activity) => void;
}

const TimelinePreviewComponent: React.FC<TimelinePreviewProps> = ({ onEdit }) => {
    const { groupedActivities } = useReportBuilder();

    const title = <Label className={styles.timelineTitle}>Activity Timeline</Label>;

    if (groupedActivities.length === 0) {
        return (
            <>
                {title}
                <div className={styles.timelineEmpty}>
                    <FontAwesomeIcon
                        icon={faClockRotateLeft}
                        className={styles.timelineEmptyIcon}
                    />
                    <p className={styles.timelineEmptyTitle}>No Activities Yet</p>
                    <p className={styles.timelineEmptyMessage}>Your registered activities will appear here.</p>
                </div>
            </>
        );
    }

    return (
        <>
            {title}
            <Timeline>
                {groupedActivities.map(group => (
                    <TimelineGroup
                        key={group.dateKey}
                        label={group.activities[0].date}
                    >
                        {group.activities.map(activity => (
                            <ReportActivityTimelineItem
                                key={activity.uuid}
                                activity={activity}
                                onEdit={onEdit}
                            />
                        ))}
                    </TimelineGroup>
                ))}
            </Timeline>
        </>
    );
};

export const TimelinePreview = React.memo(TimelinePreviewComponent);
